import React, { Component, createRef } from 'react';
import { toast } from "react-toastify";
import Tooltip from 'react-bootstrap/Tooltip';
import Card from 'react-bootstrap/Card';
import { Link } from "react-router-dom";
import CancelIcon from '@material-ui/icons/Cancel';
import { IoInformation } from "react-icons/io5";
import Accordion from 'react-bootstrap/Accordion';
import { Button, Form, Table } from 'react-bootstrap';
import AddSharpIcon from "@material-ui/icons/AddSharp";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Overlay from 'react-bootstrap/Overlay';
import DeleteSharpIcon from '@material-ui/icons/DeleteSharp';
import { TfiSettings } from "react-icons/tfi";
import { PiCopy, PiEye, PiEyeSlash, PiPlugsConnected } from "react-icons/pi";
import ChevronRightSharpIcon from '@material-ui/icons/ChevronRightSharp';
import ArrowBackOutlinedIcon from '@material-ui/icons/ArrowBackOutlined';
import ArrowForwardOutlinedIcon from '@material-ui/icons/ArrowForwardOutlined';

import axios from '../../../../axios';
import apiError from '../../../../error';
import TestEmailModal from '../../../create-template/attacker-profile/testemail';
import { getCookie } from '../../../../function';
import Spinner from '../../../spinner/spinner';
import { featuresObj } from '../../../../globalData';
import DebouncedLoader from '../../../loader/debounced-loader';

export default class AttackProfile extends Component {
    constructor(props) {
        super(props);
        this.state = {
            host: '',
            data: {},
            email: '',
            show: false,
            username: '',
            loading: false,
            isLoaded: false,
            password: '*****',
            allDisabled: false,
            billingType: getCookie('billingType'),

            domains: [],
            senderName: '',
            domainName: '',
            senderEmailName: '',

            fakeCC: [],
            fakeCCEmail: '',

            headerKey: '',
            headerValue: '',
            headers: [],
            isDMI: false,
            fakeCCFeature: featuresObj['fake-cc'],

            //for Vishing(inbound)
            gatewayNameIds: {},
            authToken: '', //auth token
            sId: '', //account sid
            callerId: '', //phone number
            gatewayId: '1',
            gatewayPhoneNumbers: [],

            //for exotel
            apiKey: '',

            whatsappMetaApiString: '',
            whatsappMetaWebhookUrl: '',
            whatsappMetaApiVisible: false,
            whatsappMetaApiCopyTooltip: false,
            whatsappMetaWebhookVisible: false,
            whatsappMetaWebhookCopyTooltip: false,
        }
        this.whatsappMetaApiCopyBtnRef = createRef();
        this.whatsappMetaWebhookCopyBtnRef = createRef();
    }

    componentDidMount = () => {
        this.load();
        this.loadDomain();
        this.loadDMISetting();
        this.loadGatway();
        if (this.isAiWhatsapp()) {
            this.loadWhatsappMetaSecrets();
        }
        // this.fetchFakeCCFeature();
    }

    componentWillUnmount() {
        if (this._apiCopyTipHideTimer) {
            clearTimeout(this._apiCopyTipHideTimer);
            this._apiCopyTipHideTimer = null;
        }
        if (this._webhookCopyTipHideTimer) {
            clearTimeout(this._webhookCopyTipHideTimer);
            this._webhookCopyTipHideTimer = null;
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.senderId !== this.props.senderId) {
            this.load();
        }
        if (
            prevProps.attackType !== this.props.attackType ||
            prevProps.targetInteractionType !== this.props.targetInteractionType ||
            prevProps.isAIbased !== this.props.isAIbased
        ) {
            if (this.isAiWhatsapp()) {
                this.loadWhatsappMetaSecrets();
            } else {
                this.setState({
                    whatsappMetaApiString: '',
                    whatsappMetaWebhookUrl: '',
                    whatsappMetaApiVisible: false,
                    whatsappMetaApiCopyTooltip: false,
                    whatsappMetaWebhookVisible: false,
                    whatsappMetaWebhookCopyTooltip: false,
                });
            }
        }
    }

    loadWhatsappMetaSecrets = () => {
        if (!this.isAiWhatsapp()) return;
        axios.get('/api/meta/getwebhook', {})
            .then(res => {
                const webhookdata = res?.data?.wa_bot_token || '';
                const webhookurl = res?.data?.webhook_url || '';
                    this.setState({ whatsappMetaApiString: String(webhookdata) });
                    this.setState({ whatsappMetaWebhookUrl: String(webhookurl) });
            })
            .catch(() => {
                console.log("error loading whatsapp meta secrets");
            });
        axios.get('/api/meta/webhook', {})
            .then(res => {
                if (res.data?.data?.value != null && res.data.data.value !== '') {
                    this.setState({ whatsappMetaWebhookUrl: String(res.data.data.value) });
                }
            })
            .catch(() => { });
    }

    toggleWhatsappMetaApiVisible = () => {
        this.setState((s) => ({ whatsappMetaApiVisible: !s.whatsappMetaApiVisible }));
    }

    toggleWhatsappMetaWebhookVisible = () => {
        this.setState((s) => ({ whatsappMetaWebhookVisible: !s.whatsappMetaWebhookVisible }));
    }

    copyToClipboard = (text, successMsg) => {
        if (!text) {
            toast.info("Nothing to copy yet.");
            return;
        }
        const done = () => toast.success(successMsg || "Copied to clipboard");
        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(text).then(done).catch(() => {
                this.fallbackCopyToClipboard(text, done);
            });
        } else {
            this.fallbackCopyToClipboard(text, done);
        }
    }

    fallbackCopyToClipboard = (text, onSuccess) => {
        const ta = document.createElement("textarea");
        ta.value = text;
        ta.setAttribute("readonly", "");
        ta.style.position = "absolute";
        ta.style.left = "-9999px";
        document.body.appendChild(ta);
        ta.select();
        try {
            document.execCommand("copy");
            if (onSuccess) onSuccess();
        } catch {
            toast.error("Copy failed");
        }
        document.body.removeChild(ta);
    }

    showWhatsappMetaApiCopiedTooltip = () => {
        if (this._apiCopyTipHideTimer) {
            clearTimeout(this._apiCopyTipHideTimer);
        }
        this.setState({ whatsappMetaApiCopyTooltip: true });
        this._apiCopyTipHideTimer = setTimeout(() => {
            this.setState({ whatsappMetaApiCopyTooltip: false });
            this._apiCopyTipHideTimer = null;
        }, 2000);
    }

    copyWhatsappMetaApi = () => {
        const text = this.state.whatsappMetaApiString;
        if (!text) {
            toast.info("Nothing to copy yet.");
            return;
        }
        const onDone = () => this.showWhatsappMetaApiCopiedTooltip();
        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(text).then(onDone).catch(() => {
                this.fallbackCopyToClipboard(text, onDone);
            });
        } else {
            this.fallbackCopyToClipboard(text, onDone);
        }
    }

    showWhatsappMetaWebhookCopiedTooltip = () => {
        if (this._webhookCopyTipHideTimer) {
            clearTimeout(this._webhookCopyTipHideTimer);
        }
        this.setState({ whatsappMetaWebhookCopyTooltip: true });
        this._webhookCopyTipHideTimer = setTimeout(() => {
            this.setState({ whatsappMetaWebhookCopyTooltip: false });
            this._webhookCopyTipHideTimer = null;
        }, 2000);
    }

    copyWhatsappMetaWebhook = () => {
        const text = this.state.whatsappMetaWebhookUrl;
        if (!text) {
            toast.info("Nothing to copy yet.");
            return;
        }
        const onDone = () => this.showWhatsappMetaWebhookCopiedTooltip();
        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(text).then(onDone).catch(() => {
                this.fallbackCopyToClipboard(text, onDone);
            });
        } else {
            this.fallbackCopyToClipboard(text, onDone);
        }
    }

    isAiWhatsapp = () => (
        this.props.attackType === "WhatsApp" &&
        this.props.targetInteractionType === "inbound" &&
        this.props.isAIbased === true
    )

    /** Textarea row count grows with token length (long JWTs / multi-line). */
    // whatsappAccessTokenRows = () => {
    //     const v = this.state.authToken || "";
    //     if (!v) return 3;
    //     const lineCount = v.split(/\r\n|\r|\n/).length;
    //     const wrapLines = Math.ceil(v.length / 68);
    //     return Math.min(24, Math.max(3, lineCount, wrapLines));
    // }

    loadGatway = () => {
        axios.get('/api/voicegateway', {})
            .then(res => {
                this.setState({ gateways: res.data.voice_gateway })
                if (res.data.voice_gateway && res.data.voice_gateway.length) {
                    let gatewayNameIds = {}
                    for (var i = 0; i < res.data.voice_gateway.length; i++) {
                        gatewayNameIds[res.data.voice_gateway[i].id] = res.data.voice_gateway[i].name;
                    }
                    this.setState({ gatewayNameIds: gatewayNameIds })
                }
            })
            .catch(error => apiError(error))
    }


    load = () => {
        if (this.props.senderId && this.props.senderId > 0) {
            axios.get('/api/senders/' + this.props.senderId, {})
                .then(res => {
                    let domainName = '', senderEmailName = '', senderName = '', fakeCC = [], headers = [];
                    try {
                        if (res.data.sender.from_address && res.data.sender.from_address.split("@")[1]) {
                            senderEmailName = res.data.sender.from_address.split("@")[0];
                            domainName = res.data.sender.from_address.split("@")[1];
                            if (domainName.indexOf('>') > -1) {
                                domainName = domainName.split('>')[0];
                            }
                        }
                        if (senderEmailName && senderEmailName.length && (senderEmailName).indexOf('<') > -1) {
                            senderName = senderEmailName.split("<")[0];
                            senderEmailName = senderEmailName.split("<")[1]
                        }
                        if (res.data.sender && res.data.sender.fake_ccs) {
                            for (let i = 0; i < res.data.sender.fake_ccs.length; i++) {
                                fakeCC.push(res.data.sender.fake_ccs[i].email)
                            }
                        }
                        if (res.data.sender && res.data.sender.headers) {
                            for (let i = 0; i < res.data.sender.headers.length; i++) {
                                headers.push({
                                    key: res.data.sender.headers[i].key,
                                    value: res.data.sender.headers[i].value
                                })
                            }
                        }
                    } catch (err) { }
                    this.setState({
                        fakeCC, headers, senderName, domainName,
                        host: res.data.sender.host,
                        senderEmailName: senderEmailName,
                        username: res.data.sender.username ? res.data.sender.username : '',
                        gatewayId: res.data.sender.smsGatewayId ? res.data.sender.smsGatewayId : '',
                        authToken: res.data.sender.authToken,
                        apiKey: res.data.sender.apiKey,
                        sId: res.data.sender.sId,
                        callerId: res.data.sender.callerId,
                        gatewayPhoneNumbers: [{ phoneNumber: res.data.sender.callerId }]
                    })
                    this.loadDomain()
                    if (this.isAiWhatsapp()) {
                        this.loadWhatsappMetaSecrets();
                    }
                })
                .catch(error => apiError(error))
        } else {
            this.loadDomain();
            if (this.isAiWhatsapp()) {
                this.loadWhatsappMetaSecrets();
            }
        }
    }

    validateSenderCustom = async () => {
        if (this.state.senderEmailName.length === 0) {
            toast.error("Please Enter Sender Name");
            return null;
        }
        if (this.state.domainName.length === 0) {
            toast.error("Please Select Domain");
            return null;
        }
        if (!this.state.host || this.state.host.length === 0 || (this.state.host).trim().length === 0) {
            toast.error("Please Enter SMTP Host");
            return null;
        }
        var from_address = `${this.state.senderEmailName}@${this.state.domainName}`

        if (this.state.senderName.length > 0) {
            from_address = `${this.state.senderName}<${from_address}>`
        }

        let data = {
            host: this.state.host,
            fakeCC: this.state.fakeCC,
            headers: this.state.headers,
            from_address: from_address,
            campaignTemplateId: this.props.campaignTemplateId
        }
        if (this.props.attackType === "Vishing" && this.props.targetInteractionType === "inbound") {
            if (!this.state.gatewayId || this.state.gatewayId.length === 0 || this.state.gatewayId === '-1') {
                toast.error("Please Select Voice Gateway");
                return null;
            }
            data['smsGatewayId'] = this.state.gatewayId;

            const gatewayName = this.state.gatewayNameIds[this.state.gatewayId];

            if (!this.state.authToken || this.state.authToken.length === 0) {

                if (gatewayName === "Exotel") {
                    toast.error("Please Enter Api Token");
                    return null;
                } else if (gatewayName === "Twilio") {
                    toast.error("Please Enter Auth Token");
                    return null;
                }
            }

            data['authToken'] = this.state.authToken;
            if (!this.state.sId || this.state.sId.length === 0) {
                if (gatewayName === "Exotel") {
                    toast.error("Please Enter Sender Id");
                    return null;
                } else if (gatewayName === "Twilio") {
                    toast.error("Please Enter Account SID");
                    return null;
                }
            }
            data['sId'] = this.state.sId;

            if (gatewayName === "Exotel") {
                if (!this.state.apiKey || this.state.apiKey.length === 0) {
                    toast.error("Please Enter Api Key");
                    return null;
                }
                data['apiKey'] = this.state.apiKey;
            }

            if (!this.state.callerId || this.state.callerId.length === 0) {
                toast.error("Please Enter Receiver Phone Number");
                return null;
            }
            data['callerId'] = this.state.callerId;
        }

        if (this.isAiWhatsapp()) {
            if (!this.state.authToken || this.state.authToken.length === 0) {
                toast.error("Please Enter WhatsApp Access Token");
                return null;
            }
            data['authToken'] = this.state.authToken;

            if (!this.state.callerId || this.state.callerId.length === 0) {
                toast.error("Please Enter Attacker WhatsApp Phone");
                return null;
            }
            data['callerId'] = this.state.callerId;
        }

        if (this.state.password !== "*****") {
            data['password'] = this.state.password;
            data['username'] = this.state.username;
            if (!this.state.username || this.state.username.length === 0) {
                toast.error("Please Enter UserName");
                return null;
            }
        }
        return data;
    }

    validateSenderAutomatic = () => {
        if (this.state.senderEmailName.length === 0) {
            toast.error("Please Enter Sender Name");
            return null;
        }
        if (this.state.domainName.length === 0) {
            toast.error("Please Select Domain");
            return null;
        }
        var from_address = `${this.state.senderEmailName}@${this.state.domainName}`

        if (this.state.senderName.length > 0) {
            from_address = `${this.state.senderName}<${from_address}>`
        }
        let data = {
            fakeCC: this.state.fakeCC,
            from_address: from_address,
            headers: this.state.headers,
            campaignTemplateId: this.props.campaignTemplateId
        }
        if (this.props.attackType === "Vishing" && this.props.targetInteractionType === "inbound") {
            if (!this.state.gatewayId || this.state.gatewayId.length === 0 || this.state.gatewayId === '-1') {
                toast.error("Please Select Voice Gateway");
                return null;
            }
            data['smsGatewayId'] = this.state.gatewayId;

            const gatewayName = this.state.gatewayNameIds[this.state.gatewayId];

            if (!this.state.authToken || this.state.authToken.length === 0) {

                if (gatewayName === "Exotel") {
                    toast.error("Please Enter Api Token");
                    return null;
                } else if (gatewayName === "Twilio") {
                    toast.error("Please Enter Auth Token");
                    return null;
                }
            }

            data['authToken'] = this.state.authToken;
            if (!this.state.sId || this.state.sId.length === 0) {
                if (gatewayName === "Exotel") {
                    toast.error("Please Enter Sender Id");
                    return null;
                } else if (gatewayName === "Twilio") {
                    toast.error("Please Enter Account SID");
                    return null;
                }
            }
            data['sId'] = this.state.sId;

            if (gatewayName === "Exotel") {
                if (!this.state.apiKey || this.state.apiKey.length === 0) {
                    toast.error("Please Enter Api Key");
                    return null;
                }
                data['apiKey'] = this.state.apiKey;
            }

            if (!this.state.callerId || this.state.callerId.length === 0) {
                toast.error("Please Enter Receiver Phone Number");
                return null;
            }
            data['callerId'] = this.state.callerId;
        }
        if (this.isAiWhatsapp()) {
            if (!this.state.authToken || this.state.authToken.length === 0) {
                toast.error("Please Enter WhatsApp Access Token");
                return null;
            }
            data['authToken'] = this.state.authToken;

            if (!this.state.callerId || this.state.callerId.length === 0) {
                toast.error("Please Enter Attacker WhatsApp Phone");
                return null;
            }
            data['callerId'] = this.state.callerId;
        }
        return data;
    }

    handleCreateSender = async () => {
        if (this.props.senderType === 'custom') {
            let data = await this.validateSenderCustom();
            if (data) {
                this.setState({ loading: true })
                if (this.props.senderId) {
                    data['username'] = this.state.username;
                    axios.patch('/api/senders/custom/' + this.props.senderId, data)
                        .then(res => {
                            this.setState({ loading: false })
                            this.props.handleTabChange('next');
                        })
                        .catch(error => {
                            this.setState({ loading: false })
                            apiError(error)
                        })
                } else {
                    axios.post('/api/senders/custom/', data)
                        .then(res => {
                            this.setState({ loading: false })
                            this.props.handleTabChange('next');
                            this.props.handleSenderId(res.data.sender.id);
                        })
                        .catch(error => {
                            this.setState({ loading: false })
                            apiError(error)
                        })
                }
            }
        } else {
            let data = this.validateSenderAutomatic()
            if (data) {
                this.setState({ loading: true })
                if (this.props.senderId) {
                    axios.patch('/api/senders/automatic/' + this.props.senderId, data)
                        .then(res => {
                            this.setState({ loading: false })
                            this.props.handleTabChange('next');
                        })
                        .catch(error => {
                            this.setState({ loading: false })
                            apiError(error)
                        })
                } else {
                    axios.post('/api/senders/automatic/', data)
                        .then(res => {
                            this.setState({ loading: false })
                            this.props.handleTabChange('next');
                            this.props.handleSenderId(res.data.sender.id);
                        })
                        .catch(error => {
                            this.setState({ loading: false })
                            apiError(error)
                        })
                }
            }
        }
    }

    sendTestMail = async () => {
        if (this.state.email.length === 0) {
            toast.error("Please Enter Email Id");
            return;
        }
        if (this.props.senderType === 'custom') {
            let data = await this.validateSenderCustom();
            if (data) {
                data['email'] = this.state.email;
                data['senderId'] = this.state.senderId;
                data['username'] = this.state.username;
                this.setState({ loading: true })
                axios.post('/api/senders/custom/test', data)
                    .then(res => {
                        this.setState({ show: false, loading: false })
                        toast.success('Test Email Send Successfully')
                    })
                    .catch(error => {
                        this.setState({ loading: false })
                        apiError(error)
                    })
            }
        } else {
            let data = this.validateSenderAutomatic();
            if (data) {
                data['email'] = this.state.email;
                data['senderId'] = this.state.senderId;
                this.setState({ loading: true })
                axios.post('/api/senders/automatic/test', data)
                    .then(res => {
                        this.setState({ show: false, loading: false })
                        toast.success('Test Email Send Successfully')
                    })
                    .catch(error => {
                        this.setState({ loading: false })
                        apiError(error)
                    })
            }
        }
    }

    loadDomain = () => {
        axios.get('/api/pages/url', { params: { limit: 200 } })
            .then(res => {
                let domains = [], landing_urls = res.data.landing_urls;
                for (let i = 0; i < landing_urls.length; i++) {
                    let name = landing_urls[i].name;
                    if (name) {
                        name = name.replace('https://', '');
                        name = name.replace('http://', '');
                    }
                    domains.push(name)
                }
                if (this.state.domainName && this.state.domainName.length && domains.indexOf(this.state.domainName) === -1) {
                    domains.push(this.state.domainName);
                }
                this.setState({ domains: domains })
            })
            .catch(error => {
                apiError(error)
            })
    }

    haldleFakeEmail = () => {
        const validEmailRegex = RegExp(/^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+.)+[^<>()[\].,;:\s@"]{2,})$/i);
        if (validEmailRegex.test(this.state.fakeCCEmail)) {
            let fakeCC = this.state.fakeCC;
            let fakeCCEmail = this.state.fakeCCEmail;
            let index = fakeCC.length === 0 ? -1 : fakeCC.indexOf(fakeCCEmail);
            if (index === -1) {
                fakeCC.push(fakeCCEmail)
                this.setState({ fakeCCEmail: '', fakeCC });
            } else {
                toast.warn('Same Email Id Already Added')
            }
        } else {
            toast.error('Please Enter Valid Email Id')
        }
    }

    deleteFakeCCEmail = (email) => {
        let fakeCC = this.state.fakeCC;
        const index = fakeCC.indexOf(email);
        if (index > -1) fakeCC.splice(index, 1);
        this.setState({ fakeCC });
    }

    haldleHeader = () => {
        let key = this.state.headerKey, value = this.state.headerValue;
        if (key.length === 0) {
            toast.error('Please Enter Header Key')
            return;
        }
        if (value.length === 0) {
            toast.error('Please Enter Header Value')
            return;
        }
        let headers = this.state.headers;
        headers.push({
            key, value
        })
        this.setState({ headers, headerKey: '', headerValue: '' })
    }

    deleteHeader = (key) => {
        let headers = this.state.headers, index = -1;
        for (let i = 0; i < headers.length; i++) {
            if (headers[i].key === key) {
                index = i;
                break;
            }
        }
        if (index !== -1) {
            headers.splice(index, 1);
            this.setState({ headers })
        }
    }

    loadDMISetting = () => {
        axios.get('/api/company/dmi', {})
            .then(res => {
                this.setState({
                    isDMI: res.data.isDMI
                });
            })
            .catch(err => {
                apiError(err);
            })
    }

    validateCallerId = () => {
        if (!this.state.apiKey || this.state.apiKey.length === 0) {
            toast.error("Please Enter Api Key");
            return false;
        }
        if (!this.state.authToken || this.state.authToken.length === 0) {
            toast.error("Please Enter Api Token");
            return false;
        }
        if (!this.state.sId || this.state.sId.length === 0) {
            toast.error("Please Enter Sender Id");
            return false;
        }
        return {
            apiKey: this.state.apiKey,
            apiToken: this.state.authToken,
            senderId: this.state.sId
        }
    }


    fetchExotelNumbers = async () => {
        const payload = this.validateCallerId();
        if (!payload) return;
        try {
            const res = await axios.post('/api/voice', payload);
            const callerIds = res.data.caller;
            let callerData = [];

            if (callerIds && callerIds.TwilioResponse && callerIds.TwilioResponse.IncomingPhoneNumber) {
                callerData.push(callerIds.TwilioResponse.IncomingPhoneNumber);
            }

            if (
                callerIds &&
                callerIds.TwilioResponse &&
                callerIds.TwilioResponse.IncomingPhoneNumbers &&
                Array.isArray(callerIds.TwilioResponse.IncomingPhoneNumbers.IncomingPhoneNumber) &&
                callerIds.TwilioResponse.IncomingPhoneNumbers.IncomingPhoneNumber.length
            ) {
                callerData = callerIds.TwilioResponse.IncomingPhoneNumbers.IncomingPhoneNumber;
            }

            this.setState({
                gatewayPhoneNumbers: callerData.map(num => {
                    return {
                        phoneNumber: num.PhoneNumber._text,
                        numberSid: num.Sid._text
                    }
                })
            });
            toast.success('Caller Id Reloaded Successfully');
        } catch (error) {
            apiError(error);
        }
    }


    fetchTwilioPhoneNumbers = async () => {
        try {
            if (!this.state.sId || this.state.sId.length === 0) {
                toast.error('Please enter a valid account sid');
                return;
            }
            if (!this.state.authToken || this.state.authToken.length === 0) {
                toast.error('Please enter a valid auth token');
                return;
            }
            this.setState({ loading: true });
            const res = await axios.post('/api/voice/twilio/fetch-numbers', {
                sId: this.state.sId,
                authToken: this.state.authToken
            });
            this.setState({ gatewayPhoneNumbers: res.data.twilioNumbers, loading: false });
        } catch (error) {
            this.setState({ loading: false });
            apiError(error);
        }
    }
    updateTwilioNumberWebhook = async (phoneNumber) => {
        try {
            if (!phoneNumber || phoneNumber.length === 0) {
                toast.error('Phone number not provided');
                return;
            }
            if (!this.state.sId || this.state.sId.length === 0) {
                toast.error('Please enter a valid account sid');
                return;
            }
            if (!this.state.authToken || this.state.authToken.length === 0) {
                toast.error('Please enter a valid auth token');
                return;
            }

            const selectedNumber = this.state.gatewayPhoneNumbers.find(num => num.phoneNumber === phoneNumber);

            if (!selectedNumber || !selectedNumber.numberSid) {
                toast.error('Could not find SID for the selected Twilio number.');
                return;
            }
            const numberSid = selectedNumber.numberSid;

            this.setState({ loading: true });
            const res = await axios.post('/api/voice/twilio/update-number-webhook', {
                sId: this.state.sId,
                authToken: this.state.authToken,
                numberSid: numberSid
            });
            this.setState({ loading: false, callerId: phoneNumber });
            toast.success(res.data.message);
        } catch (error) {
            this.setState({ loading: false });
            apiError(error);
        }
    }

    updateNumberWebhook = (phoneNumber) => {
        try {
            if (this.state.gatewayNameIds[this.state.gatewayId] === "Exotel") {
                //update webhooks for exotel
                this.setState({ callerId: phoneNumber });
            } else if (this.state.gatewayNameIds[this.state.gatewayId] === "Twilio") {
                this.updateTwilioNumberWebhook(phoneNumber);
            }
        } catch (error) {
            apiError(error);
        }
    }

    // fetchFakeCCFeature = async() => {
    //     try{
    // 		let res = await axios.get("/api/package/fake-cc", {});
    // 		this.setState({fakeCCFeature: res.data.isFeatureExists});
    // 	}catch(error){
    // 		apiError(error);
    // 	}
    // }

    render() {
        return (
            <>
                <div className="tabContent-block email-template-wrap">
                    <div className='rightSectionHeader'>
                        <div className="row justify-content-between d-flex align-items-center">
                            <div className="col-md-6 tab-right-header">
                                <h6>Attacker Profile</h6>
                                <p>Configure sender name and email details</p>
                            </div>
                            <div className="col-md-6 text-right">
                                <div className="d-flex float-right">
                                    <Button variant="primary" type="button" onClick={e => this.setState({ show: true })}> <AddSharpIcon className="btn-icon mr-2 ml-2"></AddSharpIcon> Send Test Email </Button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='campListGrids attackerAccordion'>
                        <Accordion>
                            <Card>
                                <Accordion.Toggle as={Card.Header} eventKey="0" className=" tableGrid">
                                    <div className="row align-items-center ">
                                        <div className="col-md-1 expandGrid mr-2"><ChevronRightSharpIcon className="right-arrow"></ChevronRightSharpIcon></div>
                                        Whitelist Our IPs for Phishing Simulations
                                    </div>
                                </Accordion.Toggle>
                                <Accordion.Collapse eventKey="0">
                                    <Card.Body>
                                        <div className="row align-items-center ">
                                            <div className="warningCard">
                                                <h5><b>Note:</b> Please whitelist our IPs below to ensure our phishing simulations and training emails reach your inbox instead of being blocked or marked as spam. For more information <a variant="link" href="https://helpdesk.threatcop.com/portal/en/kb/articles/do-i-need-to-whitelist-the-sender-id" target="_blank" rel="noopener noreferrer">Read More </a></h5>
                                                <p> (SMTP IP ) 168.245.74.19 ,  (Landing Page IP) 13.234.117.252</p>
                                            </div>
                                        </div>
                                    </Card.Body>
                                </Accordion.Collapse>
                            </Card>
                            <Card>
                                <Accordion.Toggle as={Card.Header} eventKey="1" className=" tableGrid">
                                    <div className="row align-items-center ">

                                        <div className="col-md-1 expandGrid mr-2">
                                            <ChevronRightSharpIcon className="right-arrow"></ChevronRightSharpIcon>
                                        </div>

                                        <div className='col-md-3 pl-0'>
                                            Mail Delivery Configuration
                                        </div>

                                        <div className='col-md-8 d-flex justify-content-end pr-0'>
                                            <div className='dFlex'>
                                                <Form.Check type="radio" label="DMI" name="powerOption" checked={this.state.isDMI} />
                                                <Form.Check type="radio" label="SMTP" name="powerOption" checked={!this.state.isDMI} />

                                            </div>
                                        </div>
                                    </div>
                                </Accordion.Toggle>

                                <Accordion.Collapse eventKey="1">
                                    <Card.Body>
                                        <div className="row align-items-center ">
                                            <div className="warningCard">
                                                <h5><b>Note:</b> Mail Delivery Configuration is necessary to define how emails
                                                    are delivered to users' inboxes. This setup ensures that emails are properly
                                                    routed and reach the intended recipients efficiently.</h5>
                                                <p><b>Current Setting :</b> Your current configuration is set to {this.state.isDMI ? 'Direct Mail Injection (DMI)' : 'Simple Mail Transfer Protocol (SMTP)'}.</p>

                                                <ul className='maildeliveryList mt-3'>
                                                    <li><b>1. If set to DMI:</b> Emails will be delivered directly to recipients' inboxes without passing through standard email servers.</li>
                                                    <li><b>2. If set to SMTP:</b> This method is mainly used for sending emails from a mail client (such as Outlook or Gmail) to a mail server.</li>
                                                    <li><b>3. Default Method:</b> If 'DMI Only' is selected, emails will be sent exclusively via the DMI method. If only 'DMI' is enabled, emails will first try the DMI method, and if not configured, they will use the backup method, SMTP."</li>
                                                </ul>
                                                <p className='mt-3 text-decoration-underline'>
                                                    <Link to="/settings/?tab=dmi"><TfiSettings /> Go to Settings</Link>
                                                </p>
                                            </div>
                                        </div>
                                    </Card.Body>
                                </Accordion.Collapse>
                            </Card>
                        </Accordion>
                    </div>
                    {this.props.attackType === "Vishing" && this.props.targetInteractionType === "inbound" &&
                        <div className="attackCard">
                            <div className='midCard'>
                                <div className='headerPara'>
                                    <h5>Calling Profile</h5>
                                    <p className='lead'><span className='red-star'>*</span> Choose the attacker phone number</p>
                                </div>

                                <div className='row'>
                                    <div className='col-sm-5'>
                                        <Form.Group controlId="gateway" className='mb-3'>
                                            <Form.Label>Voice gateway</Form.Label>
                                            <Form.Control as="select" disabled={this.state.disableState} value={this.state.gatewayId} onChange={e => this.setState({ gatewayId: e.target.value })} className="mt-2 mb-2">
                                                <option value="">Select Voice Gateway</option>
                                                {Object.keys(this.state.gatewayNameIds)?.map((gatwayId, index) => {
                                                    return <option key={index} value={gatwayId}>{this.state.gatewayNameIds[gatwayId]}</option>
                                                })}
                                            </Form.Control>
                                        </Form.Group>
                                    </div>
                                </div>

                                {this.state.gatewayNameIds[this.state.gatewayId] === "Twilio" && (
                                    <>
                                        <div className='row'>
                                            <div className='col-sm-5'>
                                                <Form.Group controlId="twilioAccountSid" className='mb-3'>
                                                    <Form.Label className='form-label'>Account SID</Form.Label>
                                                    <Form.Control type="text" placeholder="Enter Twilio Account SID" value={this.state.sId} onChange={e => this.setState({ sId: e.target.value })} />
                                                </Form.Group>
                                            </div>
                                        </div>
                                        <div className='row'>
                                            <div className='col-sm-5'>
                                                <Form.Group controlId="twilioAuthToken" className='mb-3'>
                                                    <Form.Label className='form-label'>Auth Token</Form.Label>
                                                    <Form.Control type="text" placeholder="Enter Twilio Auth Token" value={this.state.authToken} onChange={e => this.setState({ authToken: e.target.value })} />
                                                </Form.Group>
                                            </div>
                                        </div>
                                        {(this.state.gatewayPhoneNumbers && this.state.gatewayPhoneNumbers.length > 0) && (
                                            <div className='row'>
                                                <div className='col-sm-5'>
                                                    <Form.Group controlId="gateway" className='mb-3'>
                                                        <Form.Label>Phone numbers</Form.Label>
                                                        <Form.Control as="select"
                                                            disabled={this.state.disableState}
                                                            value={this.state.callerId}
                                                            onChange={e => this.updateTwilioNumberWebhook(e.target.value)}
                                                            className="mt-2 mb-2"
                                                        >
                                                            <option value="" disabled>Select attacker phone</option>
                                                            {this.state.gatewayPhoneNumbers?.map((number, index) => {
                                                                return <option key={index} value={number.phoneNumber}>{number.phoneNumber}</option>
                                                            })}
                                                        </Form.Control>
                                                    </Form.Group>
                                                </div>
                                            </div>
                                        )}
                                        <div className='row'>
                                            <div className='col-sm-5'>
                                                <Button variant="primary" onClick={this.fetchTwilioPhoneNumbers}>Fetch Numbers</Button>
                                            </div>
                                        </div>
                                    </>
                                )}
                                {this.state.gatewayNameIds[this.state.gatewayId] === "Exotel" && (
                                    <>
                                        <div className='row'>
                                            <div className='col-sm-5'>
                                                <Form.Group controlId="twilioAuthToken" className='mb-3'>
                                                    <Form.Label className='form-label'>Api key</Form.Label>
                                                    <Form.Control type="text" placeholder="Enter Exotel Api key" value={this.state.apiKey} onChange={e => this.setState({ apiKey: e.target.value })} />
                                                </Form.Group>
                                            </div>
                                        </div>
                                        <div className='row'>
                                            <div className='col-sm-5'>
                                                <Form.Group controlId="twilioAuthToken" className='mb-3'>
                                                    <Form.Label className='form-label'>Api Token</Form.Label>
                                                    <Form.Control type="text" placeholder="Enter Exotel Api Token" value={this.state.authToken} onChange={e => this.setState({ authToken: e.target.value })} />
                                                </Form.Group>
                                            </div>
                                        </div>
                                        <div className='row'>
                                            <div className='col-sm-5'>
                                                <Form.Group controlId="twilioAccountSid" className='mb-3'>
                                                    <Form.Label className='form-label'>Sender Id</Form.Label>
                                                    <Form.Control type="text" placeholder="Enter Exotel Sender Id" value={this.state.sId} onChange={e => this.setState({ sId: e.target.value })} />
                                                </Form.Group>
                                            </div>
                                        </div>
                                        {(this.state.gatewayPhoneNumbers && this.state.gatewayPhoneNumbers.length > 0) && (
                                            <div className='row'>
                                                <div className='col-sm-5'>
                                                    <Form.Group controlId="gateway" className='mb-3'>
                                                        <Form.Label>Phone numbers</Form.Label>
                                                        <Form.Control as="select" disabled={this.state.disableState} value={this.state.callerId} onChange={e => this.updateNumberWebhook(e.target.value)} className="mt-2 mb-2">
                                                            <option value="" disabled>Select attacker phone</option>
                                                            {this.state.gatewayPhoneNumbers?.map((number, index) => {
                                                                return <option key={index} value={number.phoneNumber}>{number.phoneNumber}</option>
                                                            })}
                                                        </Form.Control>
                                                    </Form.Group>
                                                </div>
                                            </div>
                                        )}
                                        <div className='row'>
                                            <div className='col-sm-5'>
                                                <Button variant="primary" onClick={this.fetchExotelNumbers}>Fetch Numbers</Button>
                                            </div>
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                    }
                    {this.isAiWhatsapp() &&
                        <div className="attackCard">
                            <div className='midCard'>
                                <div className="whatsapp-meta-inbound-banner">
                                    <div className="whatsapp-meta-inbound-banner__header">
                                        <span className="whatsapp-meta-inbound-banner__icon" aria-hidden>
                                            <PiPlugsConnected size={22} />
                                        </span>
                                        <div>
                                            <h5 className="whatsapp-meta-inbound-banner__title mb-1">Meta webhook setup</h5>
                                            <p className="whatsapp-meta-inbound-banner__lead mb-0">
                                                Paste the <strong>webhook URL</strong> into your Meta app and use the <strong>verify API string</strong> where Meta asks for the token.
                                            </p>
                                        </div>
                                    </div>

                                    <div className="whatsapp-meta-inbound-banner__field mt-3">
                                        <span className="whatsapp-meta-inbound-banner__label">Verify webhook URL</span>
                                        <div className="whatsapp-meta-inbound-banner__control">
                                        <code
                                            className="whatsapp-meta-inbound-banner__value"
                                            title={this.state.whatsappMetaWebhookUrl}
                                        >
                                            {this.state.whatsappMetaWebhookUrl || '—'}
                                            </code>
                                            <button
                                                type="button"
                                                ref={this.whatsappMetaWebhookCopyBtnRef}
                                                className="whatsapp-meta-inbound-banner__icon-btn"
                                                onClick={this.copyWhatsappMetaWebhook}
                                                aria-label="Copy webhook URL"
                                                disabled={!this.state.whatsappMetaWebhookUrl}
                                            >
                                                <PiCopy size={18} />
                                            </button>
                                            <Overlay
                                                show={this.state.whatsappMetaWebhookCopyTooltip}
                                                target={this.whatsappMetaWebhookCopyBtnRef.current}
                                                placement="top"
                                                rootClose
                                                onHide={() => this.setState({ whatsappMetaWebhookCopyTooltip: false })}
                                            >
                                                {(overlayProps) => (
                                                    <Tooltip id="whatsapp-meta-webhook-copied-tip" {...overlayProps}>
                                                        Copied
                                                    </Tooltip>
                                                )}
                                            </Overlay>
                                        </div>
                                    </div>

                                    <div className="whatsapp-meta-inbound-banner__field mt-3">
                                        <span className="whatsapp-meta-inbound-banner__label">Verify API string</span>
                                        <div className="whatsapp-meta-inbound-banner__control">
                                            <code
                                                className="whatsapp-meta-inbound-banner__value whatsapp-meta-inbound-banner__value--secret"
                                                title={this.state.whatsappMetaApiVisible ? this.state.whatsappMetaApiString : ''}
                                            >
                                                {this.state.whatsappMetaApiVisible
                                                    ? (this.state.whatsappMetaApiString || '—')
                                                    : '••••••••••••••••'}
                                            </code>
                                            <button
                                                type="button"
                                                className="whatsapp-meta-inbound-banner__icon-btn"
                                                onClick={this.toggleWhatsappMetaApiVisible}
                                                aria-label={this.state.whatsappMetaApiVisible ? 'Hide API string' : 'Show API string'}
                                            >
                                                {this.state.whatsappMetaApiVisible ? <PiEyeSlash size={18} /> : <PiEye size={18} />}
                                            </button>
                                            <button
                                                type="button"
                                                ref={this.whatsappMetaApiCopyBtnRef}
                                                className="whatsapp-meta-inbound-banner__icon-btn"
                                                onClick={this.copyWhatsappMetaApi}
                                                aria-label="Copy API string"
                                                disabled={!this.state.whatsappMetaApiString}
                                            >
                                                <PiCopy size={18} />
                                            </button>
                                            <Overlay
                                                show={this.state.whatsappMetaApiCopyTooltip}
                                                target={this.whatsappMetaApiCopyBtnRef.current}
                                                placement="top"
                                                rootClose
                                                onHide={() => this.setState({ whatsappMetaApiCopyTooltip: false })}
                                            >
                                                {(overlayProps) => (
                                                    <Tooltip id="whatsapp-meta-api-copied-tip" {...overlayProps}>
                                                        Copied
                                                    </Tooltip>
                                                )}
                                            </Overlay>
                                        </div>
                                    </div>

                                </div>
                                <div className='headerPara'>
                                    <h5>WhatsApp AI Profile</h5>
                                    <p className='lead'><span className='red-star'>*</span> Configure the WhatsApp bot access token and attacker phone number</p>
                                </div>

                                <div className='row'>
                                    <div className='col-12 col-lg-5'>
                                        <Form.Group controlId="whatsappAccessToken" className='mb-3'>
                                            <Form.Label className='form-label'>Access Token</Form.Label>
                                            <div className="whatsapp-access-token-with-info d-flex align-items-center">
                                                <Form.Control
                                                    as="textarea"
                                                    // rows={this.whatsappAccessTokenRows()}
                                                    rows={1}
                                                    className="whatsapp-access-token-input flex-grow-1"
                                                    placeholder="Enter WhatsApp Access Token"
                                                    value={this.state.authToken || ''}
                                                    onChange={e => this.setState({ authToken: e.target.value })}
                                                />
                                                <OverlayTrigger
                                                    placement="right"
                                                    overlay={
                                                        <Tooltip id="whatsapp-access-token-tip">
                                                            Generate a new token from your Meta Account and paste it here.
                                                        </Tooltip>
                                                    }
                                                >
                                                    <span
                                                        className="whatsapp-access-token-info-trigger d-inline-flex align-items-center justify-content-center"
                                                        role="button"
                                                        tabIndex={0}
                                                    >
                                                        <IoInformation className="tooltip-icon mb-0" />
                                                    </span>
                                                </OverlayTrigger>
                                            </div>
                                        </Form.Group>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col-sm-5'>
                                        <Form.Group controlId="whatsappAttackerPhone" className='mb-3'>
                                            <Form.Label className='form-label'>Attacker Phone</Form.Label>
                                            <div className="whatsapp-access-token-with-info d-flex align-items-center">
                                                <Form.Control
                                                    type="text"
                                                    inputMode="numeric"
                                                    autoComplete="tel"
                                                    placeholder="Enter Attacker WhatsApp Phone (digits only)"
                                                    value={this.state.callerId || ''}
                                                    onChange={(e) => {
                                                        const digitsOnly = e.target.value.replace(/\D/g, '');
                                                        this.setState({ callerId: digitsOnly });
                                                    }}
                                                />
                                                <OverlayTrigger
                                                    placement="right"
                                                    overlay={
                                                        <Tooltip id="whatsapp-attacker-phone-tip">
                                                            Enter the phone number associated with the same Meta Account. Users will continue the communicate with this number.
                                                        </Tooltip>
                                                    }
                                                >
                                                    <span
                                                        className="whatsapp-access-token-info-trigger d-inline-flex align-items-center justify-content-center"
                                                        role="button"
                                                        tabIndex={0}
                                                    >
                                                        <IoInformation className="tooltip-icon mb-0" />
                                                    </span>
                                                </OverlayTrigger>
                                            </div>
                                        </Form.Group>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    <div className="attackCard">
                        <div className='midCard'>
                            <div className='headerPara'>
                                <h5>Sender Display Name</h5>
                                <p className='lead'><span className='red-star'>*</span> This name will show in the inbox; if empty, the sender's email will display instead.</p>
                            </div>

                            <div className='row'>
                                <div className='col-sm-5'>
                                    <Form.Group controlId="from" className='mb-0'>
                                        <Form.Label className='form-label'>Sender Name </Form.Label>
                                        <Form.Control className='widthSet' type="text" placeholder="eg: your organisation name" value={this.state.senderName} onChange={e => this.setState({ senderName: e.target.value })} />
                                    </Form.Group>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="attackCard">
                        <div className='midCard'>
                            <div className='headerPara'>
                                <h5>Sender Domain</h5>
                                <p className='lead'><span className='red-star'>*</span> Email address of the sender visible to recipients. Eg: xyz@domain.com</p>
                            </div>
                            <div className="domainWrap mb-3">
                                <Form.Group className='mb-0'>
                                    <Form.Label className='form-label'>Enter Sender Name </Form.Label>
                                    <Form.Control type="text" placeholder="eg: username" value={this.state.senderEmailName} onChange={e => this.setState({ senderEmailName: e.target.value })} />
                                </Form.Group>
                                <p style={{ margin: '34px 10px 10px 10px' }}>@</p>
                                <Form.Group className='mb-0'>
                                    <Form.Label className='form-label'>{this.state.isDMI ? 'Enter Domain' : 'Select Domain'}</Form.Label>
                                    {this.state.isDMI ?
                                        <Form.Control type="text" placeholder="eg: domain.com" value={this.state.domainName} onChange={e => this.setState({ domainName: e.target.value })} />
                                        :
                                        <Form.Control as="select" value={this.state.domainName} onChange={e => this.setState({ domainName: e.target.value })}>
                                            <option value=''>Select Domain for Sender</option>
                                            {this.state.domains.map((domain, index) => <option value={domain} key={index}>{domain}</option>)}
                                        </Form.Control>
                                    }
                                </Form.Group>
                            </div>
                            {this.state.billingType === "Threatcop" ? <div className="mr-2 mt-1"> <Form.Check type="switch" onChange={this.props.handleSenderType} checked={this.props.senderType === "custom"} id="custom-switch" label="Custom" /> </div> : null}
                            {this.props.senderType === 'custom' ?
                                <div className='row'>
                                    <div className='col-sm-5'>
                                        <Form.Group controlId="host">
                                            <Form.Label>Host
                                                <OverlayTrigger
                                                    placement='top'
                                                    overlay={<Tooltip id='top'>Enter the server name for your SMTP server.</Tooltip>}>
                                                    <IoInformation className="tooltip-icon"></IoInformation>
                                                </OverlayTrigger>
                                            </Form.Label>
                                            <Form.Control className='widthSet' type="text" disabled={this.state.allDisabled} placeholder="smtp.example.com" value={this.state.host} onChange={e => this.setState({ host: e.target.value })} />
                                        </Form.Group>
                                    </div>

                                    <div className='col-sm-5'>
                                        <Form.Group controlId="formPlaintextEmail">
                                            <Form.Label>Username
                                                <OverlayTrigger
                                                    placement='top'
                                                    overlay={<Tooltip id='top'>This mode help you to classify a Sender ID</Tooltip>}>
                                                    <IoInformation className="tooltip-icon"></IoInformation>
                                                </OverlayTrigger>
                                            </Form.Label>
                                            <Form.Control className='widthSet' type="text" disabled={this.state.allDisabled} autoComplete="new-user" placeholder="Username" value={this.state.username} onChange={e => this.setState({ username: e.target.value })} />
                                        </Form.Group>
                                    </div>
                                    <div className='col-sm-5'>
                                        <Form.Group controlId="formPlaintextPassword" className='mb-0'>
                                            <Form.Label>Password
                                                <OverlayTrigger
                                                    placement='top'
                                                    overlay={<Tooltip id='top'>This mode help you to classify a Sender ID</Tooltip>}>
                                                    <IoInformation className="tooltip-icon"></IoInformation>
                                                </OverlayTrigger>
                                            </Form.Label>
                                            <Form.Control className='widthSet' type="password" disabled={this.state.allDisabled} autoComplete="new-password" placeholder="*****" value={this.state.password} onChange={e => this.setState({ password: e.target.value })} />
                                        </Form.Group>
                                    </div>
                                </div> : ''
                            }

                        </div>
                    </div>
                    <div className="attackCard">
                        <div className='midCard'>
                            <div className='headerPara'>
                                <h5>Header Key Details (Optional)</h5>
                                <p className='lead'> You can configure a custom header to avoid being flagged or blocked by Google.</p>
                                <p className='lead mt-0 font-weight-bold'>Eg: Key="Purpose", Value="Employee Training"</p>
                            </div>
                            <Form.Group controlId="from">
                                <div className="row mb-3">
                                    <div className='col-sm-5'>
                                        <Form.Group className='mb-0'>
                                            <Form.Label className='form-label'>Header Key </Form.Label>
                                            <Form.Control type="text" placeholder="Enter header key" value={this.state.headerKey} onChange={e => this.setState({ headerKey: e.target.value })} />
                                        </Form.Group>
                                    </div>

                                    <div className='col-sm-5'>
                                        <Form.Group className='mb-0 '>
                                            <Form.Label className='form-label'>Header Value </Form.Label>
                                            <Form.Control type="text" placeholder="Enter header value" value={this.state.headerValue} onChange={e => this.setState({ headerValue: e.target.value })} />
                                        </Form.Group>
                                    </div>

                                    <div className='col-sm-2 d-flex align-items-center'>
                                        <Form.Group className='mb-0 mr-2'>
                                            <Form.Label className='form-label'>&nbsp;</Form.Label>
                                            <Button className="setbtnPadding" onClick={this.haldleHeader}>Add</Button>
                                        </Form.Group>
                                    </div>
                                </div>
                                {this.state.headers?.length > 0 &&
                                    <div className='tableContainerWrapInner'>
                                        <Table className="training-table" borderless>
                                            <thead>
                                                <tr>
                                                    <th>Header Key</th>
                                                    <th>Header Value</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.headers.map((data, index) => {
                                                    return (
                                                        <tr key={index} className='setbgColor'>
                                                            <td>{data.key}</td>
                                                            <td>{data.value}</td>
                                                            <td>
                                                                <Button className="btn-danger-rgba deletebtn" onClick={e => this.deleteHeader(data.key)}><DeleteSharpIcon className="table-icon text-danger"></DeleteSharpIcon></Button>
                                                            </td>
                                                        </tr>
                                                    )
                                                })}
                                            </tbody>
                                        </Table>
                                    </div>
                                }
                            </Form.Group>
                        </div>
                    </div>
                    <div className="attackCard">
                        <div className='midCard'>
                            <div className='headerPara'>
                                <h5>Fake CC (Optional)</h5>
                                <p className='lead'>Utilize this function to include a dummy email in the cc field for recipients. It's important to note that the email used in the fake cc will not actually receive the message, but recipients will be able to see it</p>
                            </div>
                            <OverlayTrigger
                                placement="top"
                                overlay={
                                    this.state.fakeCCFeature ? (
                                        <Tooltip id="top" className="d-none" />
                                    ) : (
                                        <Tooltip id="top">Upgrade your plan</Tooltip>
                                    )
                                }
                            >
                                <div className="row mb-0">
                                    <div className='col-sm-5'>
                                        <Form.Group className='mb-0 '>
                                            <Form.Label className='form-label'>Enter Email Id's</Form.Label>
                                            <Form.Control className=' w-100' type="text" placeholder="Enter CC EmailId" value={this.state.fakeCCEmail} onChange={e => this.setState({ fakeCCEmail: e.target.value })} disabled={!this.state.fakeCCFeature} />
                                        </Form.Group>
                                    </div>

                                    <div className='col-sm-5 d-flex align-items-center'>
                                        <Form.Group className='mb-0'>
                                            <Form.Label className='form-label'>&nbsp;</Form.Label>
                                            <Button className="setbtnPadding" onClick={this.haldleFakeEmail} disabled={!this.state.fakeCCFeature}>Add Email</Button>
                                        </Form.Group>
                                    </div>

                                </div>
                            </OverlayTrigger>

                            {/* <div className="row mb-0">
                                <div className='col-sm-5'>
                                    <Form.Group className='mb-0 '>
                                        <Form.Label className='form-label'>Enter Email Id's</Form.Label>
                                        <Form.Control className=' w-100' type="text" placeholder="Enter CC EmailId" value={this.state.fakeCCEmail} onChange={e => this.setState({ fakeCCEmail: e.target.value })} disabled={!this.state.fakeCCFeature}/>
                                    </Form.Group>
                                </div>

                                <div className='col-sm-5 d-flex align-items-center'>
                                    <Form.Group className='mb-0'>
                                        <Form.Label className='form-label'>&nbsp;</Form.Label>
                                        <Button className="setbtnPadding" onClick={this.haldleFakeEmail} disabled={!this.state.fakeCCFeature}>Add Email</Button>
                                    </Form.Group>
                                </div>

                            </div> */}
                            {this.state.fakeCC.map((email, index) => {
                                return <span key={index} pill className="mt-2 primaryBadge mb-2 d-inline-block" variant="primary">
                                    {email} {' '} <CancelIcon className="training-icon" onClick={() => this.deleteFakeCCEmail(email)}></CancelIcon>
                                </span>
                            })}
                        </div>
                    </div>
                </div>
                <div className="mt-2">
                    <div className='footer-wrapper justify-content-end d-flex ft-padding'>
                        <Button variant="secondary" className="btn closeBtn mr-2" onClick={e => this.props.handleTabChange('prev')}><ArrowBackOutlinedIcon className="btn-icon"></ArrowBackOutlinedIcon> Previous</Button>
                        <Button variant="success" disabled={this.state.loading} type="button" onClick={this.handleCreateSender}><Spinner loading={this.state.loading}></Spinner><ArrowForwardOutlinedIcon className={this.state.loading ? "btn-icon d-none" : "btn-icon"}></ArrowForwardOutlinedIcon> Go To Next</Button>
                    </div>
                </div>
                <TestEmailModal
                    show={this.state.show}
                    email={this.state.email}
                    loading={this.state.loading}
                    sendTestMail={this.sendTestMail}
                    handleEmail={e => this.setState({ email: e.target.value })}
                    handleEmailModal={e => this.setState({ show: !this.state.show })}
                ></TestEmailModal>
                <DebouncedLoader loading={this.state.loading} />
            </>
        )
    }
}
